module.exports = __webpack_public_path__ + "static/media/电机驱动模块.a175f130.png";